document.addEventListener('DOMContentLoaded', () => {
  const recipeCommentBtn = document.querySelector('#recipe-comment-btn');
  const commentSection = document.querySelector(
    '#comments-form.comments__form'
  );

  if (recipeCommentBtn && commentSection) {
    recipeCommentBtn.addEventListener('click', () => {
      commentSection.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const articleRecipe = document.querySelector('.article_recipe');
  const articleContentMeta = document.querySelector('.article_content');
  if (articleRecipe && articleContentMeta) {
    const articleContentMetaSocial = articleContentMeta.querySelector(
      '.article__meta-social'
    );
    if (articleContentMetaSocial) {
      const articleRecipeMetaSocial = articleRecipe.querySelector(
        '.article__meta-social'
      );
      articleRecipeMetaSocial.classList.add('recipe-meta-show');
      articleContentMetaSocial.classList.add('content-meta-hide');
    }

    const articleContentMetaTags = articleContentMeta.querySelector(
      '.article__meta-tags'
    );

    if (articleContentMetaTags) {
      const articleRecipeMetaTags = articleRecipe.querySelector(
        '.article__meta-tags'
      );
      articleRecipeMetaTags.classList.add('recipe-meta-show');
      articleContentMetaTags.classList.add('content-meta-hide');
    }
  }
});
